module.exports = __webpack_public_path__ + "img/ornament-849.b459bac0.png";